<template>
  <v-progress-circular :class="classes" :size="size" :width="width" :value="progress" :indeterminate="!progress" color="primary">{{ progress }}</v-progress-circular>
</template>

<script>

export default {
  props: {
    progress: { type: Number },
    size: { type: Number, default: 70 },
    width: { type: Number, default: 5 },
    centered: { type: Boolean, default: true }
  },
  computed: {
    classes() {
      return !this.centered || 'centered'
    }
  }
}
</script>

<style lang="scss" scoped>
$spinner-size: 4rem;

.centered {
  width: $spinner-size;
  height: $spinner-size;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: 0 - $spinner-size/2;
  margin-left: 0 - $spinner-size/2;
  z-index: 100;
}
</style>
